import { IDocumentObjectsInformation } from "./IDocumentObjectsInformation";
import { DocumentObjectsInformationSection } from "./DocumentObjectsInformationSection";

export class DocumentObjectsInformation implements IDocumentObjectsInformation {
  sections: DocumentObjectsInformationSection[];
}
